import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import { Routes, Route } from 'react-router-dom';
import { GrPrevious } from 'react-icons/gr';
import { Link } from 'react-router-dom';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styless
import 'swiper/css';

/* 컴포넌트 */
import Header from '../components/Header';
import Footer from '../components/Footer';

/* 아이콘 */
import { AiOutlineUser } from "react-icons/ai";

const Experience01 = () => {
    return (
        <>
            {/* 헤더 */}
            <Header />
            {/* 컨텐츠 */}
            <Routes>
                <Route path='/' element={
                    <>
                        <div className='Eslide'>
                            <Link to='/Experience'><GrPrevious className='Eprev' /></Link>
                            <p className='ex_name1'>체험단</p>
                            <Link to='/' className='me1'><AiOutlineUser /></Link>
                        </div>
                        <Swiper
                            id='swiper_4'
                            spaceBetween={10}
                            slidesPerView={1}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >
                            <SwiperSlide className='ex_shop1 ex_shop'></SwiperSlide>
                            <SwiperSlide className='ex_shop2 ex_shop'></SwiperSlide>
                            <SwiperSlide className='ex_shop3 ex_shop'></SwiperSlide>
                            <SwiperSlide className='ex_shop4 ex_shop'></SwiperSlide>
                        </Swiper>
                        <div className='swiper4_tit'>
                            <p>[강남] 르블라썸 </p>
                            <p>펌 or 염색 or 클리닉</p>
                            <ul>
                                <li className='blog'>
                                    <img src={process.env.PUBLIC_URL + '/img/blog.png'} alt='blog' />
                                </li>
                                <li className='insta'>
                                    <img src={process.env.PUBLIC_URL + '/img/insta.png'} alt='insta' />
                                </li>
                            </ul>
                        </div>
                        <div className='swiper4_con'>
                            <p><span>-캠페인 신청기간</span>06.22 ~ 07.02</p>
                            <p><span>-캠페인 결과발표</span>07.05</p>
                        </div>
                        <div className='swiper4_con1'>
                            <p>제공내역</p>
                            <p><em>펌 or 염색 or 클리닉 중 택1</em><br/>
                                ※ 얼굴 공개 필수 캠페인으로 신중한 신청 부탁드립니다.<br/>
                                - 위 시술이 가능하신 분들은 신청 옵션에서 선택해주시길 바랍니다.<br/>
                                - 해당 시술 뿐만 아니라 다른 시술 체험도 가능합니다.</p>
                        </div>
                        <div className='swiper4_con2'>
                            <p>참고사항</p>
                            <p><em>펌 or 염색 or 클리닉 중 택1</em><br/>
                                ※ 얼굴 공개 필수 캠페인으로 신중한 신청 부탁드립니다.<br/>
                                - 위 시술이 가능하신 분들은 신청 옵션에서 선택해주시길 바랍니다.<br/>
                                - 해당 시술 뿐만 아니라 다른 시술 체험도 가능합니다.</p>
                        </div>
                        <div className='swiper4_num'>
                            <p>캠페인 정보</p>
                            <p><span>신청</span>6&nbsp;/&nbsp;16</p>
                        </div>
                        <div className='swiper4_submit'>
                            <p>신청하기</p>
                        </div>
                    </>
                } />
            </Routes>
            {/* 푸터 */}
            <Footer />
        </>
    )
};

export default Experience01;